import helpers from '../helpers';
import introItems from './intro';

function hide() {
	gsap.timeline({
		onStart() {
			$('.intro__content').add('.intro__items').removeClass('is-hidden');
			helpers.$html.removeClass('is-lock-scroll');

			if ($('.test').length) {
				$('[data-step="1"] [data-step="intro"]').removeClass('is-hidden');
			} else {
				introItems.init();
			}
		},
	})
		.to('.recomendation', {
			autoAlpha: 0,
		});
}

function init() {
	if (!helpers.isMobile()) {
		$('.intro__content').add('.intro__items').removeClass('is-hidden');

		if ($('.test').length) {
			$('[data-step="1"] [data-step="intro"]').removeClass('is-hidden');
			helpers.$document.trigger('show-test-intro', [$('.main').last().data('name')]);
			gsap.from($('[data-step="1"] [data-step="intro"]').find('> *'), {
				y: 100,
				autoAlpha: 0,
				stagger: 0.2,
				delay: 1,
				duration: 0.3,
				clearProps: 'all',
				onStart() {
					$('[data-step="1"] [data-step="intro"]').find('> *').css({
						transition: 'none',
					});
				},
			});
		}

		return;
	}

	if (helpers.getCookie('recommendation') || innerWidth > innerHeight) {
		$('.intro__content').add('.intro__items').removeClass('is-hidden');

		if ($('.test').length) {
			$('[data-step="1"] [data-step="intro"]').removeClass('is-hidden');
			helpers.$document.trigger('show-test-intro', [$('.main').last().data('name')]);
			gsap.from($('[data-step="1"] [data-step="intro"]').find('> *'), {
				y: 100,
				autoAlpha: 0,
				stagger: 0.2,
				delay: 1,
				duration: 0.3,
				clearProps: 'all',
				onStart() {
					$('[data-step="1"] [data-step="intro"]').find('> *').css({
						transition: 'none',
					});
				},
			});
		}
	} else if (innerWidth < innerHeight) {
		gsap.timeline({
			onStart() {
				helpers.$html.addClass('is-lock-scroll');
				$('.recomendation').removeClass('is-hidden');
			},
		})
			.to('.loader', {
				autoAlpha: 0,
			})
			.from(['.recomendation__title', '.recomendation__text', '.recomendation__picture', '.recomendation__button'], {
				y: 100,
				autoAlpha: 0,
				stagger: 0.3,
				clearProps: 'all',
				ease: 'back.out(2)',
			})
			.to('.recomendation__image--1', {
				opacity: 0.4,
				delay: 0.5,
			})
			.to('.recomendation__image--2', {
				rotate: '+=90deg',
				boxShadow: '5px -3px 0px rgba(0, 0, 0, 0.16)',
				bottom: '3%',
				ease: 'back.out(2)',
			});
	}

	helpers.$body.on('click.intro', '.js-recomendation-skip', () => {
		helpers.setCookie('recommendation', true, 7);
		hide();
	});

	helpers.$window.on('orientationchange.intro', () => {
		setTimeout(() => {
			if (innerWidth >= innerHeight) {
				helpers.setCookie('recommendation', true, 7);
				hide();
			}
		}, 300);
	});
}

export default {
	init,
};
